import React from "react";
import ErrorGeneric from "@pages/Error/components/ErrorGeneric";
const Error500: React.FC = () => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <ErrorGeneric
      errorTitle="Service temporarily unavailable"
      errorDescription="The application in temporarily unavailable. Please wait a few minutes
          and try again."
      errorImage="/error500.svg"
      handleReload={handleReload}
    />
  );
};

export default Error500;
